module.exports = __webpack_public_path__ + "img/cert4.6e699575.png";